import { Ship } from './../../Ship';
import { MerchantService } from '../../services/merchant.service';
import { EntitlementService } from '../../services/entitlement.service';
import { Merchant } from './../../Merchant';
import { Component, OnInit } from '@angular/core';
import { ShipService } from '../../services/ship.service';
import { ToastrService } from 'ngx-toastr';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-merchant-search',
  templateUrl: './merchant-search.component.html',
  styleUrls: ['./merchant-search.component.css']
})
export class MerchantSearchComponent implements OnInit {
  submitted = false;
  whichView = 'none';
  processing = false;
  selectedMerchant: string;
  selectedPage = 1;
  results: Merchant[];
  pagedResults: Merchant[];
  ships: string[];
  itemsPerPage = 25;
  searchTerm = '';
  selectedLocation = '';
  merchantSearchForm: UntypedFormGroup;

  constructor(
    private entitlementService: EntitlementService,
    private merchantService: MerchantService,
    private shipService: ShipService,
    private toastrService: ToastrService
  ) { }

  selectLocation(location: any) {
    this.selectedLocation = location.value;
  }

  pageSet(page) {
    this.selectedPage = page;
    this.setPagedResults();
  }

  ngOnInit() {
    this.initForm();
    const selectedLocationIn = this.merchantService.getPassedParam(
      'selectedLocation'
    );
    this.selectedLocation = selectedLocationIn ? selectedLocationIn : '';

    const searchTermIn = this.merchantService.getPassedParam('searchTerm');
    this.searchTerm = searchTermIn ? searchTermIn : '';

    this.merchantService.clearPassedParams();

    const recentMerchants = this.merchantService.getRecentMerchants();
    if (recentMerchants.length > 0) {
      this.results = recentMerchants;
      this.setPagedResults();
      this.whichView = 'results';
    }

    this.processing = true;
    this.shipService.getShips().subscribe(
      (data: Ship[]) => {
        const someships = data;
        this.ships = someships.map(ship => {
          return ship.shipName;
        });
      },
      () => {
        console.log('There was an error fetching ship information.');
      },
      () => {
        this.processing = false;
      }
    );

    if (this.searchTerm || this.selectedLocation) {
      this.processing = true;
      this.submit();
    }
  }

  initForm() {
    this.merchantSearchForm = new UntypedFormGroup({
      'searchTerm': new UntypedFormControl('', { validators: [Validators.minLength(2)], updateOn: 'change' })
    });
    this.onChange();
  }

  onChange() {
    this.merchantSearchForm.get('searchTerm').valueChanges.subscribe(
      (searchTerm: string) => {
        this.searchTerm = searchTerm;
        this.merchantSearchForm.controls['searchTerm'].markAsTouched();
      }
    );
  }

  hasEntitlement(entitlement) {
    return this.entitlementService.hasEntitlement(entitlement);
  }

  submit() {

    if (this.selectedLocation === '' && this.searchTerm === '') {
      this.whichView = 'inputErr';
      return false;
    }
    this.processing = true;
    this.whichView = 'none';
    this.pagedResults = [];
    this.merchantService
      .getMerchants(this.selectedLocation, this.searchTerm)
      .subscribe(
        data => {
          if (data.length > 0) {
            this.results = data;
            this.setPagedResults();
            this.whichView = 'results';
          } else {
            this.whichView = 'noResults';
            this.toastrService.error('No merchants Found');
          }
        },
        () => {
          console.log('There was a problem fetching merchant data');
          this.toastrService.error('There was a problem fetching merchant data');
          this.processing = false;
        },
        () => {
          this.processing = false;
          const button = document.getElementById('searchButton');
          button.blur();
        }
      );
  }

  setPagedResults() {
    if (this.results.length <= 25) {
      this.pagedResults = this.results;
    } else {
      this.pagedResults = this.results.slice(
        (this.selectedPage - 1) * this.itemsPerPage,
        (this.selectedPage - 1) * this.itemsPerPage + this.itemsPerPage
      );
    }
  }
}
